import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes } from "react-router-dom";

import './App.css';
import FullScreenLoader from './pages/FullScreenLoader';
import AppRouter from './pages/AppRouter';
import Login from './pages/Login';
import Layout from './pages/Layout';
import apiClient from './apiClient';
import { useDispatch, useSelector } from 'react-redux';
import { applicationId, assetCategoryId, assetFilterId, UNO_URL } from './env';
import { saveConfig } from './store/slice/configSlice';
import { USER_DETAILS } from './apiClient/apiEndpoints';
import axios from 'axios';
import { saveUserData } from './store/slice/userSlice';
import { getAllXRModuleTags, getAssetTagsList } from './pages/utils/operation';
import { addAssetCategories } from './store/slice/tagsSlice';


function App() {
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);



  const getConfigurationData = async () => {
    try {
      const { data } = await apiClient.get(`${UNO_URL}/api/application/configuration/${applicationId}`);
      const config = { ...data };
      // config.UNO_URL = "http://localhost:3003";
      // config.SSO_URL = "http://localhost:5000";
      dispatch(saveConfig({ data: config }));
      getUserDetails(config.UNO_URL);
      getAllXRModuleTags();
      getAssetTagsList(assetFilterId);
    } catch (error) {
          console.log(error);
    }
  };

  useEffect(() => {
    getConfigurationData();
  }, []);

  useEffect(() => {
     if(userData.token){
      setIsLoggedIn(true);
      setLoading(false)
    }else{
       setIsLoggedIn(false);
     }
  }, [userData]);

  const getAll3DAssetCategoryList = async(URL) =>{
       try {
        const data  = await apiClient.get(`${URL}/api/tag/category/list/resources/${assetCategoryId}`);
        dispatch(addAssetCategories(data))
        
       } catch (error) {
        console.log(error);
       }
  }

  const getUserDetails = async(URL) =>{
    try {
      const token = localStorage.getItem('token');
  
      if(token){
        let response = await axios.get(`${URL}${USER_DETAILS}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        localStorage.setItem("token", response?.data?.data?.token);
        const data = {
              token: response?.data?.data?.token,
              user: response?.data?.data?.user,
            };
        dispatch(saveUserData(data));
        setIsLoggedIn(true);
        getAll3DAssetCategoryList(URL);
      }  
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  }

  return (
    <>
      <HelmetProvider>
        {loading ? (
          <FullScreenLoader loading={loading} />
        ) : (
          <>

            <BrowserRouter>
            {isLoggedIn ?
              <Layout> 
                 <Routes>
                  <Route path='*' element={<AppRouter />} />
                </Routes>
              </Layout>
                :
              <Routes> 
                <Route path="/login" element={<Login />} />
                <Route path='*' element={<Navigate to="/login" />} /> 
              </Routes >
            }

            </BrowserRouter>
          </>
        )}
      </HelmetProvider>
    </>
  )
}

export default App;
